import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { getRestoLogin, toastStyle } from "../../Helpers/Utils/Common";

//components
import Table from "../../Components/TableTemplate/Table";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import ViewModal from "../../Components/Modals/ViewModal";
import EditModal from "../../Components/Modals/EditModal";
import InputError from "../../Components/InputError/InputError";

//css
//api
import { refreshPage } from "../../Helpers/Utils/Common";
import {
  createDiscount,
  deleteDiscount,
  // getAllDiscounts,
  updateDiscount,
} from "../../Helpers/apiCalls/DiscountApi";

import { validateDiscount } from "../../Helpers/Validation/Admin/DiscountValidation";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";

export default function Discount() {
  const [inactive, setInactive] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  // VIEW
  const [showViewDiscountModal, setShowViewDiscountModal] = useState(false);
  const handleCloseViewDiscountModal = () => setShowViewDiscountModal(false);
  // EDIT
  const [showEditDiscountModal, setShowEditDiscountModal] = useState(false);
  const handleshowEditDiscountModal = () => setShowEditDiscountModal(true);
  const handleCloseEditDiscountModal = () => setShowEditDiscountModal(false);
  // ADD
  const [showAddDiscountModal, setShowAddDiscountModal] = useState(false);
  const handleshowAddDiscountModal = () => setShowAddDiscountModal(true);
  const handleCloseAddDiscountModal = () => setShowAddDiscountModal(false);
  //API
  const [discountsData, setDiscountsData] = useState([]);
  const [editDiscount, setEditDiscount] = useState({});
  const [addDiscount, setAddDiscount] = useState({
    name: "",
    percentage: "",
    amount: "",
    is_percentage: "0",
    use_net_for_discount: "0",
    open_discount_amount: "0",
    item_discount: "0",
    print_approval_copy: "0",
    open_discount_rate: "0",
    ref_no: "0",
    ref_name: "0",
    suspend_discount: "0",
    is_vat_exempt: "0",
  });

  const [checked, setChecked] = useState(false);
  const checkboxHandler = () => {
    setChecked(!checked);
  };

  //REQUIRED ERROR HANDLING
  const [isError, setIsError] = useState({
    name: false,
    percentage: false,
    amount: false,
  });

  //DROPDOWN
  function handleSelectChange(e, row) {
    setSelectedRow(row);
    setEditDiscount(row);
    if (e.target.value === "delete-user") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-user") {
      handleShowDiscount(row.id);
      handleshowEditDiscountModal();
    } else {
      refreshPage();
    }
  }

  function ActionBtn(row) {
    if (parseInt(row.id) < 5) {
    } else {
      return (
        <Form.Select
          name="action"
          className="PO-select-action form-select"
          id={row.id}
          onChange={(e) => handleSelectChange(e, row)}
          value={["Select"]}
        >
          <option defaulValue selected hidden>
            Select
          </option>
          <option value="edit-user" className="color-options">
            Edit
          </option>
          <option value="delete-user" className="color-red">
            Delete
          </option>
        </Form.Select>
      );
    }
  }

  async function fetchDiscounts() {
    setShowLoader(true);
    // const response = await getAllDiscounts();
    const response = await UseGetRequest("discounts/getAll", {}, getRestoLogin());
    if (response.data) {
      let discount = response.data.all_discounts;
      discount.forEach((info) => {
        info.suspend_discount =info.suspend_discount === "1" ? "SUSPENDED" : "";
        setDiscountsData((prev) => [...prev, info]);
      });
    } else {
      setDiscountsData([]);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  // ----------------------------------------------------------------------------------------------------------
  //ADD or CREATE DISCOUNT
  const handleAddChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === "is_percentage") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "use_net_for_discount") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "open_discount_amount") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "item_discount") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "print_approval_copy") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "open_discount_rate") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
        is_percentage: checked ? "1" : "0",
      }));
    } else if (name === "ref_no") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "ref_name") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "suspend_discount") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "is_vat_exempt") {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else {
      setAddDiscount((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  //Create API Discount
  async function create() {
    if (validateDiscount(addDiscount, setIsError)) {
      const response = await createDiscount(addDiscount, selected, getRestoLogin());
      if (response.data) {
        toast.success(response.data.data.message.message, {
          style: toastStyle(),
        });
        handleCloseAddDiscountModal();
        refreshPage();
      } else {
        toast.error(response.error.data.messages.error, {
          style: toastStyle(),
        });
      }
    } else {
      toast.error("An error has occured!", { style: toastStyle() });
    }
  }

  // ----------------------------------------------------------------------------------------------------------
  //EDIT or UPDATE DISCOUNT
  const handleEditChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === "is_percentage") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "use_net_for_discount") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "open_discount_amount") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "item_discount") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "print_approval_copy") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "open_discount_rate") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "ref_no") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "ref_name") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "suspend_discount") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else if (name === "is_vat_exempt") {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: checked ? "1" : "0",
      }));
    } else {
      setEditDiscount((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  async function update() {
    if (validateDiscount(editDiscount, setIsError)) {
      const response = await updateDiscount(editDiscount, getRestoLogin());
      if (response.data) {
        toast.success(response.data.message.success, { style: toastStyle() });
        handleCloseEditDiscountModal();
        refreshPage();
      } else {
        toast.error("Error Updating New Discount", { style: toastStyle() });
      }
    }
  }

  //View On Edit Discount
  function handleOnEdit() {
    handleCloseViewDiscountModal();
    handleshowEditDiscountModal();
  }

  async function handleShowDiscount(id) {
    // const response = await getShowDiscounts(id);
    const response = await UseGetRequest("discounts/show/"+id, {}, getRestoLogin() )
    if (response.data) {
      setEditDiscount(response.data);
    } else {
      toast.error(response.error.data.messages.error, { style: toastStyle() });
    }
  }

  //DELETE or REMOVE MENU
  async function handleDeleteDiscount() {
    const response = await deleteDiscount(selectedRow.id, getRestoLogin());
    if (response.data) {
      toast.success(response.data.message.success, { style: toastStyle() });
      handleCloseDeleteModal();
      refreshPage();
    } else {
      toast.error(response.error.data.messages.error, { style: toastStyle() });
    }
  }

  useEffect(() => {
    fetchDiscounts();
  }, []);

  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="page">
        <NavbarAdmin
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"Discounts"}
          page={"Discounts"}
        />
      </div>
      <div className={`container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-3">
          <Col xs={10}>
            <label className="page-title-menu">
              DISCOUNT MANAGER{" "}
            </label>
          </Col>
          <Col xs={2} className="d-flex justify-content-end">
            <button
              className="category-new-export-btn"
              onClick={handleshowAddDiscountModal}
            >
              Add
            </button>
          </Col>
        </Row>
        <div className="table-content">
          {/* TABLE */}
          <Table
            tableHeaders={["NAME", "PERCENTAGE", "AMOUNT", "REMARK", "ACTIONS"]}
            headerSelector={[
              "name",
              "percentage",
              "amount",
              "suspend_discount",
            ]}
            tableData={discountsData}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
          />
        </div>
      </div>
      {/* MODALS */}
      <DeleteModal
        text="discount"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteDiscount}
      />
      <AddModal
        title="DISCOUNT"
        type="user"
        show={showAddDiscountModal}
        onHide={handleCloseAddDiscountModal}
        onSave={create}
      >
        <div className="mt-3 edit-form">
          <Row>
            <Col xs={6}>
              <Row className="nc-modal-custom-row">
                <Col>
                  NAME
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="name"
                    value={addDiscount.name}
                    className="nc-modal-custom-input"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.name}
                    message={"Name is Required"}
                  />
                </Col>
              </Row>
              <Row className="nc-modal-custom-row">
                <Col>
                  <input
                    id="checkbox-1"
                    class="checkbox-custom"
                    name="is_percentage"
                    type="checkbox"
                    onClick={checkboxHandler}
                    onChange={(e) => handleAddChange(e)}
                    checked={addDiscount.is_percentage === "1" ? true : false}
                  />
                  <label for="checkbox-1" class="checkbox-custom-label">
                    PERCENTAGE
                  </label>
                </Col>
                {addDiscount.is_percentage === "1" && (
                  <Col>
                    PERCENTAGE
                    <span className="required"> * </span>
                    <Form.Control
                      type="number"
                      name="percentage"
                      value={addDiscount.percentage}
                      className="nc-modal-custom-input"
                      onChange={(e) => handleAddChange(e)}
                      required
                    />
                    <InputError
                      isValid={isError.percentage}
                      message={"Percentage is Required"}
                    />
                  </Col>
                )}
              </Row>
              <Row className="nc-modal-custom-row">
                {addDiscount.is_percentage === "0" && (
                  <Col>
                    AMOUNT
                    <span className="required"> * </span>
                    <Form.Control
                      type="number"
                      name="amount"
                      // disabled={checked}
                      value={addDiscount.amount}
                      className="nc-modal-custom-input"
                      onChange={(e) => handleAddChange(e)}
                      required
                    />
                    <InputError
                      isValid={isError.amount}
                      message={"Amount is Required"}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            <Col xs={6}>
              {/* <Row className="nc-modal-custom-row">
              <label class="checkbox-custom-label">APPLY TO (Item):</label>
                <MultiSelect
                options={menuItems}
                value={selected}
                onChange={setSelected}
                labelledBy="Select"
                />
            </Row> */}
              <Row>
                <Col>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="use_net_for_discount"
                      id="use_net_for_discount"
                      type="checkbox"
                      onChange={(e) => handleAddChange(e)}
                      checked={
                        addDiscount.use_net_for_discount === "1" ? true : false
                      }
                    />
                    <label
                      for="use_net_for_discount"
                      class="checkbox-custom-label"
                    >
                      USE NET FOR DISCOUNT
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="open_discount_amount"
                      id="open_discount_amount"
                      type="checkbox"
                      onChange={(e) => handleAddChange(e)}
                      checked={
                        addDiscount.open_discount_amount === "1" ? true : false
                      }
                    />
                    <label
                      for="open_discount_amount"
                      class="checkbox-custom-label"
                    >
                      OPEN DISCOUNT AMOUNT
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="item_discount"
                      id="item_discount"
                      type="checkbox"
                      onChange={(e) => handleAddChange(e)}
                      checked={addDiscount.item_discount === "1" ? true : false}
                    />
                    <label for="item_discount" class="checkbox-custom-label">
                      ITEM DISCOUNT
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="print_approval_copy"
                      id="print_approval_copy"
                      type="checkbox"
                      onChange={(e) => handleAddChange(e)}
                      checked={
                        addDiscount.print_approval_copy === "1" ? true : false
                      }
                    />
                    <label
                      for="print_approval_copy"
                      class="checkbox-custom-label"
                    >
                      PRINT APPROVAL COPY
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="open_discount_rate"
                      id="open_discount_rate"
                      type="checkbox"
                      onChange={(e) => handleAddChange(e)}
                      checked={
                        addDiscount.open_discount_rate === "1" ? true : false
                      }
                    />
                    <label
                      for="open_discount_rate"
                      class="checkbox-custom-label"
                    >
                      OPEN DISCOUNT RATE
                    </label>
                  </Row>
                </Col>
                <Col>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="ref_no"
                      id="ref_no"
                      type="checkbox"
                      onChange={(e) => handleAddChange(e)}
                      checked={addDiscount.ref_no === "1" ? true : false}
                    />
                    <label for="ref_no" class="checkbox-custom-label">
                      REFERENCE NO.
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="ref_name"
                      id="ref_name"
                      type="checkbox"
                      onChange={(e) => handleAddChange(e)}
                      checked={addDiscount.ref_name === "1" ? true : false}
                    />
                    <label for="ref_name" class="checkbox-custom-label">
                      REFERENCE NAME
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="suspend_discount"
                      id="suspend_discount"
                      type="checkbox"
                      onChange={(e) => handleAddChange(e)}
                      checked={
                        addDiscount.suspend_discount === "1" ? true : false
                      }
                    />
                    <label for="suspend_discount" class="checkbox-custom-label">
                      SUSPEND DISCOUNT
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="is_vat_exempt"
                      id="is_vat_exempt"
                      type="checkbox"
                      onChange={(e) => handleAddChange(e)}
                      checked={addDiscount.is_vat_exempt === "1" ? true : false}
                    />
                    <label for="is_vat_exempt" class="checkbox-custom-label">
                      WITH VAT EXEMPT
                    </label>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </AddModal>
      <EditModal
        title="DISCOUNT"
        type="menu"
        show={showEditDiscountModal}
        onHide={handleCloseEditDiscountModal}
        onSave={update}
      >
        <div className="mt-3 edit-form">
          <Row>
            <Col>
              <Row className="nc-modal-custom-row">
                <Col>
                  NAME
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="name"
                    value={editDiscount.name}
                    className="nc-modal-custom-input"
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.name}
                    message={"Name is Required"}
                  />
                </Col>
              </Row>
              <Row className="nc-modal-custom-row">
                <Col>
                  <input
                    id="is_percentage"
                    class="checkbox-custom"
                    name="is_percentage"
                    type="checkbox"
                    onClick={checkboxHandler}
                    onChange={(e) => handleEditChange(e)}
                    checked={editDiscount.is_percentage === "0" ? false : true}
                    // defaultChecked={editDiscount.is_percentage === "1"}
                  />
                  <label for="is_percentage" class="checkbox-custom-label">
                    PERCENTAGE
                  </label>
                </Col>
                {editDiscount.is_percentage === "1" ? (
                  <Col>
                    PERCENTAGE
                    <span className="required"> * </span>
                    <Form.Control
                      type="number"
                      name="percentage"
                      value={editDiscount.percentage}
                      className="nc-modal-custom-input"
                      onChange={(e) => handleEditChange(e)}
                      required
                    />
                    <InputError
                      isValid={isError.percentage}
                      message={"Percentage is Required"}
                    />
                  </Col>
                ) : (
                  <Col>
                    AMOUNT
                    <span className="required"> * </span>
                    <Form.Control
                      type="number"
                      name="amount"
                      // disabled={checked}
                      value={editDiscount.amount}
                      className="nc-modal-custom-input"
                      onChange={(e) => handleEditChange(e)}
                      required
                    />
                    <InputError
                      isValid={isError.amount}
                      message={"Amount is Required"}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            <Col xs={6}>
              {/* <Row className="nc-modal-custom-row">
                <label class="checkbox-custom-label">APPLY TO (Item):</label>
                  <MultiSelect
                  options={menuItems}
                  value={selected}
                  onChange={setSelected}
                  labelledBy="Select"
                />
              </Row> */}
              <Row>
                <Col>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="use_net_for_discount"
                      id="use_net_for_discount"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={
                        editDiscount.use_net_for_discount === "0" ? false : true
                      }
                    />
                    <label
                      for="use_net_for_discount"
                      class="checkbox-custom-label"
                    >
                      USE NET FOR DISCOUNT
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="open_discount_amount"
                      id="open_discount_amount"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={
                        editDiscount.open_discount_amount === "0" ? false : true
                      }
                    />
                    <label
                      for="open_discount_amount"
                      class="checkbox-custom-label"
                    >
                      OPEN DISCOUNT AMOUNT
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="item_discount"
                      id="item_discount"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={
                        editDiscount.item_discount === "0" ? false : true
                      }
                    />
                    <label for="item_discount" class="checkbox-custom-label">
                      ITEM DISCOUNT
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="print_approval_copy"
                      id="print_approval_copy"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={
                        editDiscount.print_approval_copy === "0" ? false : true
                      }
                    />
                    <label
                      for="print_approval_copy"
                      class="checkbox-custom-label"
                    >
                      PRINT APPROVAL COPY
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="open_discount_rate"
                      id="open_discount_rate"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={
                        editDiscount.open_discount_rate === "0" ? false : true
                      }
                    />
                    <label
                      for="open_discount_rate"
                      class="checkbox-custom-label"
                    >
                      OPEN DISCOUNT RATE
                    </label>
                  </Row>
                </Col>
                <Col>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="ref_no"
                      id="ref_no"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={editDiscount.ref_no === "0" ? false : true}
                    />
                    <label for="ref_no" class="checkbox-custom-label">
                      REFERENCE NO
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="ref_name"
                      id="ref_name"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={editDiscount.ref_name === "0" ? false : true}
                    />
                    <label for="ref_name" class="checkbox-custom-label">
                      REFERENCE NAME
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="suspend_discount"
                      id="suspend_discount"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={
                        editDiscount.suspend_discount === "0" ? false : true
                      }
                    />
                    <label for="suspend_discount" class="checkbox-custom-label">
                      SUSPEND DISCOUNT
                    </label>
                  </Row>
                  <Row className="nc-modal-custom-row">
                    <input
                      class="checkbox-custom"
                      name="is_vat_exempt"
                      id="is_vat_exempt"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={
                        editDiscount.is_vat_exempt === "0" ? false : true
                      }
                    />
                    <label for="is_vat_exempt" class="checkbox-custom-label">
                      WITH VAT EXEMPT
                    </label>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </EditModal>
      <ViewModal
        withButtons
        show={showViewDiscountModal}
        onHide={handleCloseViewDiscountModal}
        onEdit={handleOnEdit}
      >
        <div>
          <div className="col-sm-12 space">
            <span className="custom-modal-body-title-user-details">
              DISCOUNT DETAILS
            </span>
            <div className="mt-3 container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col lg={12}>
                  NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {selectedRow.name} </Col>
                  </Row>
                </Col>
                <Col lg={12}>
                  PERCENTAGE
                  <Row className="nc-modal-custom-row">
                    <Col> {selectedRow.percentage} </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>
      <div>
        <label className="powered-label pt-3 text-center">
          Powered by MYT SofDev Solutions Inc. EPSOS 1.0.0
        </label>
      </div>
    </div>
  );
}
